import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ResearchAssistantService } from '../../services/research-assistant.service';
import { Job } from '../../models/job.interface';
import { AlertModalComponent } from '../../alert-modal/alert-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { JobResult } from 'src/app/models/job_result.interface';
import { CognitoService } from 'src/app/services/cognito.service';

@Component({
  selector: 'app-view-research-dialog',
  templateUrl: './view-research-dialog.component.html',
  styleUrls: ['./view-research-dialog.component.scss']
})
export class ViewResearchDialogComponent implements OnInit {
  userJobs: Job[] = [];
  publishedJobs: Job[] = [];
  ongoingJobs: Job[] = [];
  user = '';

  constructor(
    public dialogRef: MatDialogRef<ViewResearchDialogComponent>,
    // TODO: Add Type
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Inject(MAT_DIALOG_DATA) public data: any,
    private researchAssistantService: ResearchAssistantService,
    private cognitoService: CognitoService,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.fetchUserJobs();
    this.fetchPublishedJobs();
    this.fetchOngoingJobs();

    this.cognitoService
      .getUserId()
      .then(userId => {
        this.user = userId;
      })
      .catch(error => {
        console.error('Error retrieving user id:', error);
      });
  }

  fetchUserJobs() {
    this.researchAssistantService.getJobs().subscribe({
      next: (jobs: Job[]) => {
        this.userJobs = jobs.filter(item => item.job_status === 'Completed');
      },
      error: err => console.error('Error fetching jobs:', err)
    });
  }

  fetchPublishedJobs() {
    this.researchAssistantService.getPublishedJobs().subscribe({
      next: (jobs: Job[]) => {
        this.publishedJobs = jobs;
      },
      error: err => console.error('Error fetching jobs:', err)
    });
  }

  fetchOngoingJobs() {
    this.researchAssistantService.getJobs().subscribe({
      next: (jobs: Job[]) => {
        this.ongoingJobs = jobs.filter(item => ['Starting', 'In Progress'].includes(item.job_status));
      },
      error: err => console.error('Error fetching jobs:', err)
    });
  }

  publishJob(job: Job) {
    this.researchAssistantService.publishJob(job.job_id, true).subscribe({
      // TODO: Add Type
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      next: (response: any) => {
        console.log(response);
        this.fetchPublishedJobs();
        this.fetchUserJobs();
        this.openAlert('Success', 'Successfully published job.');
      },
      error: err => {
        console.error('Error publishing job:', err);
        this.openAlert('Failed', 'Could not publish job.');
      }
    });
  }

  unpublishJob(job: Job) {
    if (this.user === job.requested_by) {
      this.researchAssistantService.publishJob(job.job_id, false).subscribe({
        // TODO: Add Type
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        next: (response: any) => {
          console.log(response);
          this.fetchPublishedJobs();
          this.fetchUserJobs();
          this.openAlert('Success', 'Successfully unpublished job.');
        },
        error: err => {
          console.error('Error unpublishing job:', err);
          this.openAlert('Failed', 'Could not unpublish job.');
        }
      });
    } else {
      console.log('User does not have permission to unpublish job');
    }
  }

  deleteJob(job: Job) {
    this.researchAssistantService.deleteJob(job.job_id).subscribe({
      next: () => {
        this.fetchUserJobs();
        this.openAlert('Success', 'Successfully deleted job.');
        this.fetchUserJobs();
        this.fetchPublishedJobs();
        this.fetchOngoingJobs();
      },
      error: err => {
        console.error('Error deleting job:', err);
        this.openAlert('Failed', 'Could not delete job.');
      }
    });
  }

  getProgressValue(job: Job): number {
    const progress = parseFloat(job.progress) * 100;
    return Math.round(progress);
  }

  openAlert(title: string, message: string): void {
    this.dialog.open(AlertModalComponent, {
      data: {
        title: title,
        message: message
      }
    });
  }

  openJobResult(job: Job) {
    this.researchAssistantService.getJobResult(job.job_id).subscribe((jobResults: JobResult[]) => {
      const newTab = window.open();
      const htmlContent = `
        <!DOCTYPE html>
        <html lang="en">
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>Job Results</title>
          <style>
            body {
              font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
              margin: 0;
              padding: 0;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              min-height: 100vh;
            }
            h1, h3 {
              text-align: center;
            }
            table {
              width: 80%;
              margin: 20px auto;
              border-collapse: collapse;
              border-radius: 8px;
              overflow: hidden;
            }
            th, td {
              border: 1px solid #444;
              padding: 12px 15px;
              text-align: left;
              white-space: pre-wrap;
            }
            th {
              font-size: 1.1em;
            }
            tr:nth-child(even) {
              background-color: #333;
            }
            
            @media (max-width: 768px) {
              table {
                width: 95%;
              }
            }
          </style>
        </head>
        <body>
          <h1>${job.prompt_title}</h1>
          <h3>${job.user_prompt}</h3>
          <table>
            <thead>
              <tr>
                <th>Document</th>
                <th>Model Response</th>
              </tr>
            </thead>
            <tbody>
              ${jobResults
                .map(
                  jobResult => `
                <tr>
                  <td>${jobResult.document_title}</td>
                  <td>${jobResult.model_response.replace(/\n/g, '<br/>')}</td>
                </tr>
              `
                )
                .join('')}
            </tbody>
          </table>
        </body>
        </html>
      `;

      if (newTab) {
        newTab.document.write(htmlContent);
        newTab.document.close();
      }
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
